<template>
    <div class="faq-container">
        <div class="container">
            <div class="inner-page-title">News</div>
            <div class="terms-body">
                <div class="news-wrapper" v-for="(news, i) in newsList" :key="i">
                    <div class="news-image" v-bind:style="{ backgroundImage: 'url(' + news.image + ')' }"></div>
                    <div class="news-info">
                        <div class="news-title">{{news.title}}</div>
                        <div class="news-text" v-html="news.subtitle"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "News",
        head: {
            title: 'News | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'page-news trading-desk'
            }
        },
        data() {
            return {
                newsList: [
                    {
                        title: 'News article title goes here, can be long and split over two lines',
                        subtitle: 'You can brows the Vindome website and application without being registered. However, in order to trade with us, you will need to create an account. Click here to register.</br></br>We offer two ways of investing and buying wines:</br></br>"Collections" these are carefully selected collections of wine that you can easily purchase by a click of a button to start your wine investment journey.',
                        image: require('@/assets/app/image.png')
                    },
                    {
                        title: 'News article title goes here, can be long and split over two lines',
                        subtitle: 'You can brows the Vindome website and application without being registered. However, in order to trade with us, you will need to create an account. Click here to register.</br></br>We offer two ways of investing and buying wines:</br></br>"Collections" these are carefully selected collections of wine that you can easily purchase by a click of a button to start your wine investment journey.',
                        image: require('@/assets/app/image.png')
                    },
                    {
                        title: 'News article title goes here, can be long and split over two lines',
                        subtitle: 'You can brows the Vindome website and application without being registered. However, in order to trade with us, you will need to create an account. Click here to register.</br></br>We offer two ways of investing and buying wines:</br></br>"Collections" these are carefully selected collections of wine that you can easily purchase by a click of a button to start your wine investment journey.',
                        image: require('@/assets/app/image.png')
                    },
                    {
                        title: 'News article title goes here, can be long and split over two lines',
                        subtitle: 'You can brows the Vindome website and application without being registered. However, in order to trade with us, you will need to create an account. Click here to register.</br></br>We offer two ways of investing and buying wines:</br></br>"Collections" these are carefully selected collections of wine that you can easily purchase by a click of a button to start your wine investment journey.',
                        image: require('@/assets/app/screen1.png')
                    },
                    {
                        title: 'News article title goes here, can be long and split over two lines',
                        subtitle: 'You can brows the Vindome website and application without being registered. However, in order to trade with us, you will need to create an account. Click here to register.</br></br>We offer two ways of investing and buying wines:</br></br>"Collections" these are carefully selected collections of wine that you can easily purchase by a click of a button to start your wine investment journey.',
                        image: require('@/assets/app/image.png')
                    }
                ]
            }
        }
    }
</script>

<style scoped>
    .faq-container {
        background: #ffffff;
        padding-top: 80px;
    }

    .container {
        max-width: 1366px;
        padding: 0;
        font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    }

    .inner-page-title {
        font-size: 49px;
        line-height: 49px;
        text-align: center;
        color: #303030;
        margin-top: 47px;
        margin-bottom: 53px;
    }

    .terms-body {
        padding: 30px 0;
        font-size: 16px;
        font-weight: 400;
    }

    .news-wrapper {
        padding: 53px 91px 63px;
        height: 598px;
        width: 100%;
    }

    .news-image {
        background: #F6F6F6;
        width: 482px;
        height: 482px;
        margin-right: 118px;
        display: inline-block;
        background-repeat: no-repeat;
        background-position: center;
    }

    .news-info {
        display: inline-block;
        width: calc(100% - 600px);
        vertical-align: top;
        padding-top: 98px;
    }

    .news-title {
        font-size: 33px;
        line-height: 33px;
        font-weight: 600;
        color: #303030;
        margin-bottom: 32px;
    }

    .news-text {
        font-size: 16px;
        line-height: 26px;
        font-weight: 300;
        color: #000000;
    }
</style>
